import {
    BdsGrid,
    BdsLoadingSpinner,
    BdsTable,
    BdsTableBody,
    BdsTableCell,
    BdsTableHeader,
    BdsTableRow,
    BdsTableTh,
} from 'blip-ds/dist/blip-ds-react/components';
import { TableRowEmptyState } from 'components/TableRowEmptyState';
import { useTranslation } from 'react-i18next';
import { TagsTableProps } from 'typings';

export const TagsTable: React.FC<TagsTableProps> = ({ data, isLoading, isAllBots }: TagsTableProps) => {
    const { t } = useTranslation();
    return (
        <>
            {isLoading ? (
                <BdsGrid xxs="12" alignItems="center" justifyContent="center" height="250px" padding="t-5">
                    <BdsLoadingSpinner />
                </BdsGrid>
            ) : (
                <div className="data-block-table data-block-table--tags">
                    <BdsTable>
                        <BdsTableHeader>
                            <BdsTableRow>
                                <BdsTableTh justifyContent="left">{t('go-personal-table-column-tag')}</BdsTableTh>
                                <BdsTableTh justifyContent="center">
                                    {t('go-personal-table-column-closed-tickets')}
                                </BdsTableTh>
                                {!isAllBots && (
                                    <BdsTableTh justifyContent="center">{t('go-personal-table-column-avg-time')}</BdsTableTh>
                                )}
                            </BdsTableRow>
                        </BdsTableHeader>
                        <BdsTableBody>
                            {data.map(tag => (
                                <BdsTableRow key={tag.name}>
                                    <BdsTableCell justifyContent="left">{tag.name}</BdsTableCell>
                                    <BdsTableCell justifyContent="center">{tag.closedTickets.amount}</BdsTableCell>
                                    {!isAllBots && (
                                        <BdsTableCell justifyContent="center">
                                            {tag.closedTickets.timeMetrics[0].avg}
                                        </BdsTableCell>
                                    )}
                                </BdsTableRow>
                            ))}
                        </BdsTableBody>
                    </BdsTable>
                    {data.length === 0 && (
                        <TableRowEmptyState isSearch={false} messageWhenNoItems={t('go-personal-table-empty-state')} />
                    )}
                </div>
            )}
        </>
    );
};
